export default __webpack_public_path__ + "static/media/banner3.a3e7c7d5.jpg";